export default __webpack_public_path__ + "assets/icon-co2_cloud.svg";